<template>
  <div class="LongQuanSiJi">
    <!-- <BaseSearch></BaseSearch> -->
    <div style="margin-top: 2.5rem"></div>
    <div class="wrap">
      <ScrollLoad :noText="noText">
        <div class="container">
          <ul class="container-left">
            <li class="container-item" v-for="(item, index) in imgLtList" :key="index" @click="handleClickImgView(item)">
              <img :src="item.imgPath" alt="" class="container-item-img" />
              <span class="container-item-text">【{{ item.materialTitle }}】</span>
            </li>
          </ul>
          <div class="container-line"></div>
          <ul class="container-right">
            <li class="container-item" v-for="(item, index) in imgRtList" :key="index" @click="handleClickImgView(item)">
              <img :src="item.imgPath" alt="" class="container-item-img" />
              <span class="container-item-text">【{{ item.materialTitle }}】</span>
            </li>
          </ul>
        </div>
      </ScrollLoad>
      <div class="none-content" v-show="noImg">
        <img src="~@/assets/img/none-img.png" alt="" class="none-content-img" />
        <span class="none-content-text">{{ imgStateText }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { queryFileInfoResourceByTagName } from '@/api/http/index.js'
import { imgUrl } from '@/api/http/baseURL.js'
import { _updatePages } from '@/utils/tool.js'
export default {
  name: 'LongQuanSiJi',
  data() {
    return {
      // 子标题导航内容
      lineData: [
        { id: 0, label: '春景', tagName: '龙泉山春景' },
        { id: 1, label: '夏景', tagName: '龙泉山夏景' },
        { id: 2, label: '秋景', tagName: '龙泉山秋景' },
        { id: 3, label: '冬景', tagName: '龙泉山冬景' }
      ],
      isImgShow: false,
      noImg: false,
      viedeoShow: false,
      pageImgData: [], // 页面数据
      imgParams: {
        current: 1,
        fileInfoType: 'FILE_TYPE_PICTURE',
        size: 10,
        fileName: '',
        tagName: '龙泉山春景'
      },

      imgPages: 0,
      imgCurrent: 0,
      videoCurrent: 0,
      videoPages: 0,
      imgStateText: '加载中...',
      noText: false
    }
  },
  created() {},
  mounted() {
    //  拿到小程序页面栈数量
    _updatePages(this.$route.fullPath)

    // 下拉事件
    this.$EventBus.$on('ScrollCallback', () => {
      // 索引是1时不加载
      if (this.imgParams.current != 1) this.queryImgData()
    })
    // 点击右侧目录事件
    this.$EventBus.$on('backIndex', index => {
      this.pageImgData = []
      this.imgParams.tagName = this.lineData[index].tagName
      this.imgParams.current = 1
      this.$EventBus.$emit('scrollNoMore', false)
      console.log('触发')
      this.queryImgData()
    })
    this.queryImgData()
    // 渲染侧边目录
    let params = {
      label: '龙泉福地',
      subLabel: '龙泉四季',
      subNav: this.lineData
    }
    this.$EventBus.$emit('injectNav', params)
  },
  beforeDestroy() {
    this.$EventBus.$off('backIndex')
  },
  computed: {
    // 图片左侧数据
    imgLtList() {
      return this.pageImgData.filter((item, index) => (index + 1) % 2 !== 0)
    },
    // 图片右侧数据
    imgRtList() {
      return this.pageImgData.filter((item, index) => (index + 1) % 2 === 0)
    }
  },
  methods: {
    handleClickImgView(item) {
      // console.log('🌏 => 龙泉四季', item)
      this.$linkWx({ instance: item.materialId, url: '/pages/ViewImage', imgPath: item.filePath })
    },
    handleClickVideoPlay(path) {
      this.viedeoShow = true
      this.videoPath = path
      this.$EventBus.$emit('hasHome', false)
    },
    // 请求图片数据
    queryImgData() {
      this.imgStateText = '加载中...'
      this.$EventBus.$emit('loadEvent', true)
      queryFileInfoResourceByTagName(this.imgParams).then(
        res => {
          this.$EventBus.$emit('loadEvent', false)
          this.$EventBus.$emit('scrollLoading', false)
          if (res.records.length != 0) {
            this.imgParams.current += 1
            res.records.forEach(el => {
              el.fileThumbnail = imgUrl + el.fileThumbnail
              this.pageImgData.push({
                instanceId: el.instanceId,
                imgPath: el.fileThumbnail,
                instanceName: el.instanceName,
                materialTitle: el.materialTitle,
                filePath: el.filePath,
                id: el.id,
                materialId: el.materialId
              })
            })

            // this.imgParams.current = res.current
            this.imgPages = res.pages
          } else {
            this.imgStateText = '暂无内容'
          }
          // 当前页码等于总页码时 停止加载下一页
          if (this.imgParams.current > res.pages) {
            console.log('终止了')
            this.$EventBus.$emit('scrollNoMore', true)
          }
        },
        () => {
          // 错误处理
          this.imgStateText = '暂无内容'
          this.$EventBus.$emit('loadEvent', false)
          this.$notify({
            duration: 4000,
            position: 'top-left',
            title: '提示',
            customClass: 'relationClass',
            message: '网络错误！'
          })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.LongQuanSiJi {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .wrap {
    position: relative;

    width: inherit;
    height: calc(100% - 4.1rem);
    margin-top: 0.5rem;

    .container {
      position: relative;

      display: flex;
      justify-content: center;
      align-items: flex-start;

      width: inherit;
      padding: 0.5rem 0.72rem 0 0.72rem;
      .container-left,
      .container-right {
        width: 4.92rem;

        .container-item {
          position: relative;

          width: inherit;
          // height: auto;
          height: 6rem;
          margin-top: 1.5rem;

          border-bottom: 0.02rem solid #c5aa7e;
          // border-right: 0.02rem solid #c5aa7e;

          text-align: center;

          .container-item-text {
            display: inline-block;

            width: inherit;
            height: auto;
            // margin-top: 0.5rem;
            margin-bottom: 0.2rem;

            color: #7e5c2a;
            font-size: 0.44rem;
            font-family: '楷体';
          }
          .container-item-img {
            width: 4.5rem;
            // width: inherit;
            height: 4rem;
            object-fit: contain;
          }
        }

        .container-item:first-child {
          margin: 0;
        }
      }
      .container-line {
        position: absolute;

        height: 100%;
        border-right: 0.04rem solid #c5aa7e;

        // height: inherit;
        // border-left: 0.02rem solid #ba9963;
      }
      .container-line::before {
        content: '';
        position: absolute;
        top: -0.42rem;
        left: 50%;

        width: 0.66rem;
        height: 0.46rem;
        background-image: url('~@/assets/img/line-icon.png');
        background-size: 100% 100%;

        transform: translateX(-50%);
      }
      .container-left {
        // border: 1px solid seagreen;

        .container-item::before {
          content: '';

          position: absolute;
          bottom: -0.05rem;
          right: -0.05rem;

          width: 0.1rem;
          height: 0.1rem;
          background: #ba9963;
          border-radius: 50%;
        }
        .container-item-text {
          text-align: start;
        }
      }

      .container-right {
        padding-top: 3.8rem;

        // border-left: 0.02rem solid #ba9963;

        .container-item::before {
          content: '';

          position: absolute;
          bottom: -0.05rem;
          left: -0.05rem;

          width: 0.1rem;
          height: 0.1rem;
          background: #ba9963;
          border-radius: 50%;
        }
        .container-item-text {
          text-align: end;
        }
      }
    }

    .none-content {
      position: absolute;
      top: 40%;
      left: 50%;
      z-index: 99;
      display: flex;
      flex-direction: column;
      align-items: center;

      transform: translate(-50%, -50%);

      .none-content-img {
        width: 6.5rem;
        height: 4.15rem;
      }
      .none-content-text {
        color: #898989;
        font-size: 0.44rem;
      }
    }
  }
}
</style>